import GA from './tracking/ga'
import FbPixel from './tracking/fbPixel'

const config = {
  sendID: (id, FbTrackName) => {
    GA.userId(id, true)
    FbPixel.track(FbTrackName, id)
  },

  withoutCode: () => GA.send({
    name: 'user without code',
    category: 'promocode',
    action: 'no-code',
    label: 'promo'
  }),

  codeFound: mode => GA.send({
    name: `${mode} ok`,
    category: `${mode}code`,
    action: 'code-found',
    label: mode
  }),

  codeNotFound: () => GA.send({
    name: 'code not found',
    category: 'promocode',
    action: 'code-not-found',
    label: 'promo'
  }),

  codeActivationFailed: () => GA.send({
    name: 'promocode activation failed',
    category: 'promocode',
    action: 'activate',
    label: 'promo_failed',
  }),

  codeActivationSuccess: () => GA.send({
    name: 'promocode activate',
    category: 'promocode',
    action: 'activate',
    label: 'promo_success',
  }),

  registrationSuccess: (email, code, name, phone) => {
    GA.send({
      name: 'new account created',
      category: 'forms',
      action: 'submitted',
      label: 'register',
    })
  },
  registrationFailed: () => GA.send({
    name: 'account creation failed',
    category: 'forms',
    action: 'submitted',
    label: 'register',
  }),

  loginSuccess: (email, code, name, phone) => {
    GA.send({
      name: 'login form submitted',
      category: 'forms',
      action: 'submitted',
      label: 'login',
    })
  },

  loginFailed: () => GA.send({
    name: 'activation_error',
    label: 'invalid email or password',
  }),

  riseActivateFailed: () => GA.send({
    name: `activation_error`, // eslint-disable-line
    label: 'you cannot activate rise',
  })
}

export default config
